<template>
  <div>
    <h1>{{ $t('daynightSchedule') }}</h1>
    <div class="day_btn">
      <el-button class="blue-btn" style="float: right; margin-bottom: 14px;" @click="setSchedule">{{ $t('save') }}</el-button>
    </div>
    <div class="day_title">{{ $t('dayTitle') }}</div>
    <Table
      style="margin-top: 10px"
      :dataSource="dataSource"
      :columns="tableColumns"
    >
      <template #week>
        <el-table-column
          :label="$t('week')"
          width="120"
        >
          <template slot-scope="scope">
            {{ weekArr[scope.$index] }}
          </template>
        </el-table-column>
      </template>
      <template #operation>
        <el-table-column
          :label="$t('operation')"
        >
          <template slot-scope="scope">
            <i class="iconfont icon-shanchu pointer" @click="delRow"></i>
            <i v-if="scope.row.isEdit" class="iconfont icon-baocun pointer" @click="saveRow"></i>
          </template>
        </el-table-column>
      </template>
    </Table>
  </div>
</template>

<script>
import { getPanelDetail, setSchedule } from '../../api/panel'
import { EventBus } from '../../store/eventBus'
import config from '../../common/config'

export default {
  name: 'daynightSchedule',
  data () {
    return {
      dataSource: [],
      dataSourceCopy: [],
      weekArr: [this.$t('monday'), this.$t('tuesday'), this.$t('wednesday'), this.$t('thursday'), this.$t('friday'), this.$t('saturday'), this.$t('sunday')],
      tableColumns: [{
        slotName: 'week',
        label: this.$t('week')
      }, {
        prop: 'dayStart',
        label: this.$t('dayStart'),
        // minWidth: '320'
      }, {
        prop: 'sdd',
        label: this.$t('sensitivityProfileDuringDay'),
        // minWidth: '320'
      }, {
        prop: 'nightStart',
        label: this.$t('nightStart'),
        // minWidth: '340'
      }, {
        prop: 'sdn',
        label: this.$t('sensitivityProfileDuringNight'),
        // minWidth: '320'
      }],
      dayOptions: [{
        name: 1,
        value: 1
      }, {
        name: 2,
        value: 2
      }, {
        name: 3,
        value: 3
      }],
      id: '',
      panelId: this.$route.query.panelId,
      projectId: this.$route.query.projectId,
      editData: [],
      editDataIndex: []
    }
  },
  mounted () {
    this.getPanelDetail()
    EventBus.$on('checkSave', (cb) => {
      const data = this.handleData()
      if (data.length > 0) {
        this.checkCommit()
      } else {
        cb()
      }
    })
  },
  methods: {
    getPanelDetail () {
      getPanelDetail({
        panelId: this.panelId,
        projectId: this.projectId
      }).then(res => {
        this.id = res.data.id
        this.dataSource = res.data.calendars.map(n => {
          return {
            isEdit: true,
            id: n.id,
            dayStart: {
              value: n.dayStart,
              type: 'timePicker',
              placeholder: this.$t('notSet'),
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            },
            sdd: {
              value: n.sdd || 3,
              type: 'select',
              options: this.dayOptions,
              width: 140,
              clearable: false,
              placeholder: this.$t('notSet'),
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            },
            nightStart: {
              value: n.nightStart,
              type: 'timePicker',
              placeholder: this.$t('notSet'),
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            },
            sdn: {
              value: n.sdn || 3,
              type: 'select',
              options: this.dayOptions,
              width: 140,
              clearable: false,
              placeholder: this.$t('notSet'),
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            }
          }
        })
        this.dataSourceCopy = config.deepClone(this.dataSource)
      })
    },
    setSchedule (cb) {
      const data = this.handleData()
      if (data.length === 0) {
        this.$message.error(this.$t('notModified'))
        return
      }
      const arr = this.dataSource.map(n => {
        return {
          dayStart: n.dayStart.value,
          sdd: n.sdd.value,
          nightStart: n.nightStart.value,
          sdn: n.sdn.value,
        }
      })
      setSchedule({
        calendars: arr,
        id: this.id
      }).then(res => {
        this.$message.success(this.$t('saveSuccess'))
        this.getPanelDetail()
        this.editDataIndex = []
        this.editData = []
        if (typeof cb === 'function') {
          cb()
        }
      })
    },
    // 取消已编辑内容
    cancelEdit (done) {
      this.editDataIndex.map(n => {
        this.$set(this.dataSource, n, config.deepClone(this.dataSourceCopy[n]))
      })
      this.editDataIndex = []
      this.editData = []
      done()
    },
     // 将修改的值存起来，判断是否重复
    addDataToArr (data, index) {
      const _index = this.editDataIndex.indexOf(index)
      if ( _index === -1) {
        this.editDataIndex.push(index)
        this.editData.push(data)
      } else {
        this.editData[_index] = data
      }
    },
    handleData () {
      const keys = ['dayStart', 'sdd', 'nightStart', 'sdn']
      const data = []
      this.editDataIndex.map((n, i) => {
        const newData = this.editData[i]
        const oldData = this.dataSourceCopy[n]
        var notSave = true
        for (let i = 0, len = keys.length; i < len; i++) {
          const oldValue = oldData[keys[i]].value !== 0 ? oldData[keys[i]].value || '' : 0
          const newValue = newData[keys[i]].value !== 0 ? newData[keys[i]].value || '' : 0
          if (newValue != oldValue) {
            notSave = false
          }
        }
        if (!notSave) {
          data.push(newData)
        }
      })
      return data
    },
    checkCommit () {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('unsavedRemind'),
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.setSchedule(done)
          } else {
            this.cancelEdit(done)
            // done()
          }
        }
      }).then(action => {
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    // 在token失效时,会跳转到/，此时不必拦截
    if (to.path !== '/') {
      const data = this.handleData()
      if (data.length > 0) {
        next(false)
        this.checkCommit()
      } else {
        next()
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    EventBus.$off('checkSave')
  }
}
</script>

<style lang="less" scoped>
h1 {
  font-size: 24px;
  font-weight: 400;
}
.day_btn{
  height: 32px;
}
.day_title{
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
</style>
